import React from 'react';
import { Link } from 'react-router-dom';
import ScrollReveal from './ScrollReveal';
import FloatingOrbs from './FloatingOrbs';
import './PremiumCta.css';

interface PremiumCtaProps {
  title: string;
  paragraphs: string[];
  tagline: string;
  primaryHref: string;
  primaryLabel: string;
  secondaryHref?: string;
  secondaryLabel?: string;
}

const PremiumCta: React.FC<PremiumCtaProps> = ({
  title,
  paragraphs,
  tagline,
  primaryHref,
  primaryLabel,
  secondaryHref,
  secondaryLabel,
}) => (
  <section className="premium-cta">
    <FloatingOrbs />
    <ScrollReveal className="premium-cta__inner">
      <h2 className="premium-cta__title">{title}</h2>
      {paragraphs.map((p) => (
        <p key={p} className="premium-cta__text">
          {p}
        </p>
      ))}
      <p className="premium-cta__tagline">{tagline}</p>
      <div className="premium-cta__actions">
        <Link to={primaryHref} className="premium-cta__btn premium-cta__btn--primary">
          {primaryLabel}
        </Link>
        {secondaryHref && secondaryLabel ? (
          <Link to={secondaryHref} className="premium-cta__btn premium-cta__btn--secondary">
            {secondaryLabel}
          </Link>
        ) : null}
      </div>
    </ScrollReveal>
  </section>
);

export default PremiumCta;
